import * as z from 'zod';

import { agreementQueryLinkerSchema } from '@/_schemas/agreements/agreements-query-linker-schema';
import { companyQueryLinkerSchema } from '@/_schemas/companies/company-query-linker-schema';

import { contactQueryLinkerSchema } from './contact-query-linker-schema';

export const agreementTableSchema = agreementQueryLinkerSchema.extend({
  client: companyQueryLinkerSchema,
  agreement_contact: z.array(contactQueryLinkerSchema).nullish(),
  project_contact: z.array(contactQueryLinkerSchema).nullish(),
  billing_contact: z.array(contactQueryLinkerSchema).nullish(),
  emergency_contact: z.array(contactQueryLinkerSchema).nullish(),
  agreement_signer: contactQueryLinkerSchema.nullish(),
  roles: z.array(z.enum(['billing', 'agreement', 'project', 'emergency', 'execution_signatory'])),
});

export type AgreementTableSchema = z.infer<typeof agreementTableSchema>;

export const marketingCampaignTableSchema = z.object({
  id: z.number(),
  name: z.string().min(3),
});

export type MarketingCampaignTableSchema = z.infer<typeof marketingCampaignTableSchema>;
